export default {
  banner: {
    download: 'Tải tài liệu',
    request: 'Xem báo giá',
  },

  modal: {
    title: 'Tài liệu đang được chuẩn bị.',
    desc: 'Tài liệu sẽ được cập nhật trong thời gian sớm nhất.<br/>Vui lòng chờ một chút, xin cảm ơn.',

    download: {
      title: 'Tải tài liệu',
      desc: 'Vui lòng nhập thông tin bên dưới, chúng tôi sẽ gửi tài liệu qua email. Nếu có thắc mắc khác, vui lòng liên hệ ',
      phone: '(+82)1522-9928',
      descTail: ' để được hỗ trợ.',
      time: 'Giờ hành chính (10:00 - 19:00) (KST)',
      ph_email: 'example@orbro.io',

      agree1: '[Bắt buộc]',
      agree2: 'Chính sách bảo mật',
      agree3: 'tôi đồng ý.',

      confirm: 'Tải xuống',
      cancel: 'Hủy',
    },
    subscribe: {
      title: 'Hoàn thành gửi',
      desc: 'Chúng tôi đã gửi tài liệu đến bạn.<br/>Bạn có muốn đăng ký nhận bản tin của ORBRO để cập nhật kỹ thuật và thông tin không?',
      skip: 'Bỏ qua',
      confirm: 'Đăng ký',
    },
    done: {
      title: 'Đã đăng ký',
      desc: 'Cảm ơn bạn đã đăng ký nhận bản tin của ORBRO. Chúng tôi sẽ gửi thông tin và tin tức mới nhất qua email. Hãy cùng ORBRO khám phá thêm nhiều thông tin hữu ích.',
      confirm: 'Xác nhận',
    },
  },

  request: {
    title: 'Liên hệ',
    desc: `Nếu bạn cần triển khai giải pháp, vui lòng nhập thông tin bên dưới và nhấn 'Gửi'.`,
    name: 'Nguyễn Văn A',

    placeholder: {
      name: 'Họ tên',
    },
  },

  contents: {
    title: 'Khám phá các nội dung đa dạng',

    tag: {
      construction: 'Xây dựng',
      logistics: 'Logistics',
      office: 'Văn phòng',
      medical: 'Bệnh viện',
      manufacturing: 'Sản xuất',
      retail: 'Bán lẻ',
    },
  },

  news: {
    title: 'Cập nhật những thông tin mới nhất!',
  },
  ref: [{ text: 'Tổng quan' }, { text: 'Tóm tắt tính năng' }, { text: 'Sản phẩm khuyến nghị' }, { text: 'Blog' }, { text: 'Liên hệ' }],
};
